<template>
  <el-dialog
    title="系统提示"
    :visible="visible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="420px"
    custom-class="export-confirm-dialog"
  >
    <div class="confirm-content">
      <i class="el-icon-warning warning-icon"></i>
      <div class="confirm-body">
        <div class="confirm-message">确定导出当前搜索结果所有数据吗？</div>
        <div class="confirm-extra">
          <el-checkbox 
            v-model="exportDetail" 
            @change="handleCheckboxChange"
          >
            同步导出详细培训记录
          </el-checkbox>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportConfirmModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportDetail: false
    }
  },
  methods: {
    handleClose() {
      this.exportDetail = false;
      this.$emit('close');
    },
    handleConfirm() {
      const exportType = this.exportDetail ? 1 : 2;
      this.$emit('confirm', exportType);
      this.exportDetail = false;
    },
    handleCheckboxChange(value) {
      this.exportDetail = value;
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-content {
  display: flex;
  align-items: flex-start;
  
  .warning-icon {
    font-size: 24px;
    color: #E6A23C;
    margin-right: 12px;
    margin-top: 2px;
  }
  
  .confirm-body {
    flex: 1;
    
    .confirm-message {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
    }
    
    .confirm-extra {
      margin-top: 15px;
      
      ::v-deep .el-checkbox {
        font-weight: normal;
        color: #606266;
        
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #409EFF;
          border-color: #409EFF;
        }
        
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #606266;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  
  ::v-deep .el-button {
    padding: 9px 15px;
  }
}
</style>

<style lang="scss">
.export-confirm-dialog {
  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #DCDFE6;
  }
  
  .el-dialog__body {
    padding: 30px 20px;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #DCDFE6;
  }
}
</style>